import { render, staticRenderFns } from "./Venda.vue?vue&type=template&id=12d5f974"
import script from "./Venda.vue?vue&type=script&lang=js"
export * from "./Venda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports